import React, { useState } from 'react';
import { parseScore } from './scoring';

const RatingPanel = ({ entry, mine, onSave, onCancel }) => {
  const [score, setScore] = useState(mine ? String(mine.score) : '');
  const [note, setNote] = useState(mine?.note || '');
  const [busy, setBusy] = useState(false);

  const parsed = parseScore(score);

  const submit = async (event) => {
    event.preventDefault();
    if (parsed === null) return;
    setBusy(true);
    try {
      await onSave({ score: parsed, note });
    } finally {
      setBusy(false);
    }
  };

  return (
    <form className="helen-rate" onSubmit={submit}>
      <div className="helen-rate-row">
        <label className="helen-field is-score" htmlFor={`score-${entry.id}`}>
          <span>Your score</span>
          <input
            id={`score-${entry.id}`}
            inputMode="decimal"
            placeholder="0–10"
            value={score}
            onChange={(e) => setScore(e.target.value)}
          />
        </label>

        <label className="helen-field is-note" htmlFor={`note-${entry.id}`}>
          <span>Note</span>
          <input
            id={`note-${entry.id}`}
            placeholder="what you'll remember"
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </label>
      </div>

      <div className="helen-rate-actions">
        <button type="submit" className="helen-button is-small" disabled={parsed === null || busy}>
          {busy ? 'Saving' : 'Save'}
        </button>
        {onCancel && (
          <button type="button" className="helen-linkbutton" onClick={onCancel}>
            Cancel
          </button>
        )}
      </div>
    </form>
  );
};

export default RatingPanel;
